import React from 'react';
import './Canvas.css';
import Node from './Node';
import Arc from './Arc';
import Distance from './Distance';


export default class Canvas extends React.Component {
    state = {
        distance: 0
    }

    getDistance = (distance) => {
        this.setState({distance});
    }

    render() {
        return (
            <div className="canvas container">
                {
                this.props.distance && 
                <div className="short-distance">La valeur du plus court chemin est: <span>{this.props.distance}</span></div>
                }
                {
                this.props.clickedNode &&
                <Distance getDistance={this.getDistance}/>
                }

                {this.props.arcs.map((arc) => (
                    <Arc 
                        key={arc.id} 
                        id={arc.id}
                        distance={arc.distance}
                        nodes={
                            [
                                this.props.nodes[arc.nodes[0] - 1],
                                this.props.nodes[arc.nodes[1] - 1]
                            ]
                        }
                        type={arc.type}
                        />
                ))}

                {this.props.nodes.map((node) => (
                    <Node 
                        clickedNode={this.props.clickedNode}
                        key={node.id} {...node} 
                        pathStart={this.props.pathStart} 
                        pathEnd={this.props.pathEnd}
                        handleClickedNodes={this.props.handleClickedNodes}
                        distance={this.state.distance}
                        />
                ))}

            </div>
        );
    }
}